import { Heart, ExternalLink } from 'lucide-react';
import { useTheme } from '@/hooks/useTheme';

export function CemeteryFooter() {
  const { theme } = useTheme();
  const isScary = theme === 'dark';
  
  return (
    <footer className="relative border-t border-primary/30 bg-card/60 backdrop-blur-md mt-12">
      {isScary && <div className="fog-overlay" />}
      
      <div className="container mx-auto px-4 py-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Creator Credit */}
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <span>Built with</span>
            <Heart className="h-4 w-4 text-destructive fill-destructive animate-pulse" />
            <span>by</span>
            <a
              href="https://njump.me/npub1gxqyeea3xspkd68mxlxsvvk3gdzdd555u504ynwpdj0ghg503mvq2gydt0"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-primary hover:text-accent transition-colors inline-flex items-center gap-1"
            >
              codeorange
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
          
          {/* MKStack Credit */}
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <span>Vibed with</span>
            <a
              href="https://soapbox.pub/mkstack"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-primary hover:text-accent transition-colors inline-flex items-center gap-1"
            >
              MKStack
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
          
          {/* Shakespeare Credit */}
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <span>Powered by</span>
            <a
              href="https://shakespeare.diy"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-secondary hover:text-accent transition-colors inline-flex items-center gap-1"
            >
              Shakespeare.diy
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </div>
        
        {/* Decorative grave markers */}
        {isScary && (
          <div className="flex justify-center mt-6 text-4xl opacity-20 space-x-4">
            <span>🪦</span>
            <span>⚰️</span>
            <span>💀</span>
            <span>⚰️</span>
            <span>🪦</span>
          </div>
        )}
      </div>
    </footer>
  );
}
